import { Equipment } from '../../register-form/equipment/equipment';

/**
 * DTO used to add and/or remove equipments
 */
export class AddRemoveEquipmentRequestDTO {
  /**
   * @constructor
   */
  constructor(
    public equipmentsToAdd: Equipment[],
    public equipmentIdsToDelete: number[]
  ) {}
}
